import { useEffect } from 'react';
import { useLoading } from '../contexts/LoadingContext';
import { setLoadingManager } from '../utils/axios';

const LoadingInitializer = () => {
  const { showLoader, hideLoader } = useLoading();
  
  useEffect(() => {
    setLoadingManager({ showLoader, hideLoader });
  }, [showLoader, hideLoader]);
  
  return null;
};

export default LoadingInitializer;
